









import Vue from 'vue'
import moment from 'moment/moment'
import config from '@/utils/config'
import request from '@/utils/request'
import current from './current.vue'
import hours from './hours.vue'
import days from './days.vue'
export default Vue.extend({
    components: {current, hours, days},
    data() {
        return {
            timer: null as any,
            setIntervalTag: true,
            address: config.defaultStationObj.stationName,
            longitude: config.defaultStationObj.lon,
            latitude: config.defaultStationObj.lat,
        }
    },
    created() {
        this.getLocation()
    },
    methods: {
        getLocation() {
            const that = this
            if (navigator.geolocation) {
                // alert('支持地理定位')
                // console.log(this.setIntervalTag)
                if (this.setIntervalTag === true) {
                    // this.timer = setInterval( () => {
                        navigator.geolocation.getCurrentPosition(
                        (position) => {
                            // console.log(position)
                            // alert('经度' + position.coords.longitude)
                            // alert('纬度' + position.coords.latitude)
                            that.longitude = position.coords.longitude
                            that.latitude = position.coords.latitude
                            const params = {
                                postStr: `{'lon':${position.coords.longitude},'lat':${position.coords.latitude},'ver':1}`,
                                type: 'geocode',
                                tk: '13c72b545322ec87faf658079794c444',
                            }
                            request.get('/geocoder', params).then((res) => {
                                // console.log(res)
                                if (res) {
                                    // that.address = res.result.formatted_address
                                    that.address = res.result.addressComponent.city + res.result.addressComponent.county
                                } else {
                                    that.address = config.defaultStationObj.stationName
                                }
                            })
                        },
                        (error) => {
                            // alert('地理定位失败')
                            if (that.setIntervalTag === true) {
                                that.showError(error)
                            }
                            that.address = config.defaultStationObj.stationName
                            that.setIntervalTag = false
                            that.getLocation()
                        })
                    // }, 1000)
                } else {
                    clearInterval(this.timer);
                    this.timer = null;
                    this.address = config.defaultStationObj.stationName
                }
            } else {
                alert('不支持地理定位')
                clearInterval(this.timer);
                this.timer = null;
                this.address = config.defaultStationObj.stationName
            }
        },
        showError(error: any) {
            switch (error.code) {
                // case error.PERMISSION_DENIED:
                case 1:
                alert('定位失败,没有权限使用地理定位或用户拒绝请求地理定位')
                break;
                // case error.POSITION_UNAVAILABLE:
                case 2:
                alert('定位失败,位置信息不可用，无法确定设备的位置')
                // alert('网络不可用或者无法连接到获取位置信息的卫星')
                break;
                // case error.TIMEOUT:
                case 3:
                alert('定位失败,请求获取用户位置超时')
                break;
                // case error.UNKNOWN_ERROR:
                case 0:
                alert('定位失败,定位系统失效')
                break;
            }
            // error对象的code属性有如下属性值:
            // PERMISSION_DENIED(1):(permission_denied):用户单机信息条上的“不共享”按钮或直接拒绝被获取位置信息
            // POSITION_UNAVAILABLE(2):(position_unavailable):(position_unavailable)网络不可用或者无法连接到获取位置信息的卫星
            // TIMEOUT(3):(timeout)网络可用但在计算机用户的位置上花费过长时间
            // UNKNOWN_ERROR(0):(unknown_error)发生其他未知错误
        },
    },
    filters: {
    },
})
